import cloudWatchLogger from "./loggers/cloudWatchLogger";
import consoleLogger from "./loggers/consoleLogger";

const consoleLogEnabled = process.env.REACT_APP_CONSOLE_LOG_SERVICE_ENABLED;
const cloudWatchLogEnabled = process.env.REACT_APP_CLOUDWATCH_LOG_SERVICE_ENABLED;

const log = {
  trace: (msg) => {
    if (consoleLogEnabled) {
      consoleLogger.trace(msg);
    }

    if (cloudWatchLogEnabled) {
      cloudWatchLogger.trace(msg);
    }
  },
  debug: (msg) => {
    if (consoleLogEnabled) {
      consoleLogger.debug(msg);
    }

    if (cloudWatchLogEnabled) {
      cloudWatchLogger.debug(msg);
    }
  },
  info: (msg) => {
    if (consoleLogEnabled) {
      consoleLogger.info(msg);
    }

    if (cloudWatchLogEnabled) {
      cloudWatchLogger.info(msg);
    }
  },
  warn: (msg, error) => {
    if (consoleLogEnabled) {
      consoleLogger.warn(msg, error);
    }

    if (cloudWatchLogEnabled) {
      cloudWatchLogger.warn(msg, error);
    }
  },
  error: (msg, error) => {
    if (consoleLogEnabled) {
      consoleLogger.error(msg, error);
    }

    if (cloudWatchLogEnabled) {
      cloudWatchLogger.error(msg, error);
    }
  },
  fatal: (msg, error) => {
    if (consoleLogEnabled) {
      consoleLogger.fatal(msg, error);
    }

    if (cloudWatchLogEnabled) {
      cloudWatchLogger.fatal(msg, error);
    }
  }
};

export default log;
